import React, { useState, useEffect } from 'react';
import { BASE_URL } from '../config/api'; // Assuming BASE_URL is correctly defined in your config/api.js
import { useNavigate, useParams } from 'react-router-dom';

const EditCustomer = () => {
    const { id } = useParams(); // Get the customer ID from URL params
    const navigate = useNavigate();

    // State for customer fields
    const [name, setName] = useState('');
    const [number, setNumber] = useState('');
    const [address, setAddress] = useState('');
    const [area, setArea] = useState('');
    const [pin_code, setPinCode] = useState('');
    const [state, setState] = useState('');
    const [city, setCity] = useState('');
    const [firm_name, setFirmName] = useState('');
    const [number1, setNumber1] = useState('');
    const [number2, setNumber2] = useState('');
    const [number3, setNumber3] = useState('');

    // Fetch the customer details on component mount
    useEffect(() => {
        fetch(`${BASE_URL}customers/${id}`)
            .then(response => response.json())
            .then(data => {
                if (data.status === 1) {
                    const customer = data.data;
                    // Set the customer data from the response
                    setName(customer.name);
                    setNumber(customer.number);
                    setAddress(customer.address);
                    setArea(customer.area);
                    setPinCode(customer.pin_code);
                    setState(customer.state);
                    setCity(customer.city);
                    setFirmName(customer.firm_name);
                    setNumber1(customer.number1);
                    setNumber2(customer.number2);
                    setNumber3(customer.number3);
                }
            })
            .catch(error => console.error('Error fetching customer data:', error));
    }, [id]);

    // Handle form submission
    const handleSubmit = (event) => {
        event.preventDefault();

        const updatedCustomer = {
            name,
            number,
            address,
            area,
            pin_code,
            state,
            city,
            firm_name,
            number1,
            number2,
            number3,
        };

        fetch(`${BASE_URL}customers/${id}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(updatedCustomer),
        })
            .then(response => response.json())
            .then(data => {
                if (data.status === 1) {
                    alert("Customer updated successfully!");
                    navigate('/CustomerList'); // Navigate to the customer list page
                } else {
                    alert("Error updating customer. Please try again.");
                }
            })
            .catch(error => console.error('Error updating customer:', error));
    };

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <div className="page-title">
                    <div className="row">
                        <div className="col-12 col-md-6 order-md-1 order-last">
                            <h3>Edit Customer</h3>
                        </div>
                    </div>
                </div>
            </div>

            {/* Edit Customer Form */}
            <section className="section">
                <div className="row">
                    <div className="col-12 col-md-12">
                        <div className="card">
                            <div className="card-header">
                                <h4 className="card-title">Edit Customer Details</h4>
                            </div>
                            <div className="card-body">
                                <form onSubmit={handleSubmit}>
                                    <div className="mb-3">
                                        <label htmlFor="name" className="form-label">Customer Name</label>
                                        <input
                                            type="text"
                                            id="name"
                                            className="form-control"
                                            value={name}
                                            onChange={(e) => setName(e.target.value)}
                                            placeholder="Enter customer name"
                                            required
                                        />
                                    </div>

                                   
                                    <div className="mb-3">
                                        <label htmlFor="address" className="form-label">Address</label>
                                        <input
                                            type="text"
                                            id="address"
                                            className="form-control"
                                            value={address}
                                            onChange={(e) => setAddress(e.target.value)}
                                            placeholder="Enter address"
                                            required
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="area" className="form-label">Area</label>
                                        <input
                                            type="text"
                                            id="area"
                                            className="form-control"
                                            value={area}
                                            onChange={(e) => setArea(e.target.value)}
                                            placeholder="Enter area"
                                            required
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="pin_code" className="form-label">Pin Code</label>
                                        <input
                                            type="text"
                                            id="pin_code"
                                            className="form-control"
                                            value={pin_code}
                                            onChange={(e) => setPinCode(e.target.value)}
                                            placeholder="Enter pin code"
                                            required
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="state" className="form-label">State</label>
                                        <input
                                            type="text"
                                            id="state"
                                            className="form-control"
                                            value={state}
                                            onChange={(e) => setState(e.target.value)}
                                            placeholder="Enter state"
                                            required
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="city" className="form-label">City</label>
                                        <input
                                            type="text"
                                            id="city"
                                            className="form-control"
                                            value={city}
                                            onChange={(e) => setCity(e.target.value)}
                                            placeholder="Enter city"
                                            required
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="firm_name" className="form-label">Firm Name</label>
                                        <input
                                            type="text"
                                            id="firm_name"
                                            className="form-control"
                                            value={firm_name}
                                            onChange={(e) => setFirmName(e.target.value)}
                                            placeholder="Enter firm name"
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="number1" className="form-label">Phone 1</label>
                                        <input
                                            type="text"
                                            id="number1"
                                            className="form-control"
                                            value={number1}
                                            onChange={(e) => setNumber1(e.target.value)}
                                            placeholder="Enter phone number 1"
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="number2" className="form-label">Phone 2</label>
                                        <input
                                            type="text"
                                            id="number2"
                                            className="form-control"
                                            value={number2}
                                            onChange={(e) => setNumber2(e.target.value)}
                                            placeholder="Enter phone number 2"
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="number3" className="form-label">Phone 3</label>
                                        <input
                                            type="text"
                                            id="number3"
                                            className="form-control"
                                            value={number3}
                                            onChange={(e) => setNumber3(e.target.value)}
                                            placeholder="Enter phone number 3"
                                        />
                                    </div>

                                    <div className="text-end">
                                        <button type="submit" className="btn btn-primary">Update Customer</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* End Edit Customer Form */}
        </div>
    );
};

export default EditCustomer;
